module.exports = __webpack_public_path__ + "img/B@2x.10ec37e.jpg";